import React from "react";
import { Link } from "react-router-dom";
import { SectionTitle, Reveal } from "@/components/home/homeUi";

const WAYS = [
  {
    id: "egyeni",
    title: "Egyéni Forrás-Kód® kísérés",
    paragraphs: [
      "Személyre szabott, interaktív folyamat, amelyben a saját élethelyzeteid, kapcsolódásaid és az azok mögött megjelenő működések kerülnek a középpontba.",
      "Akkor is szeretettel várlak, ha egy konkrét párkapcsolati, családi vagy más emberi kapcsolódással szeretnél foglalkozni, és akkor is, ha egy visszatérő működés mélyebb összefüggéseit szeretnéd megérteni.",
    ],
    cta: "Érdeklődöm az egyéni kísérésről",
    to: "/forras-kod-kiseres#egyeni-kiseres",
  },
  {
    id: "csoportos",
    title: "Kis csoportos Forrás-Kód® kísérés és foglalkozások",
    paragraphs: [
      "A közös témák mentén kialakuló csoportdinamika különleges lehetőségeket nyithat az egyéni felismerésekre és az új nézőpontok megtapasztalására.",
      "Az alkalmak interaktívak, a résztvevők által behozott élethelyzetek és a közös folyamat alakulása is formálhatja őket.",
    ],
    cta: "Érdeklődöm a csoportos alkalmakról",
    to: "/forras-kod-kiseres#csoportos-kiseres",
  },
  {
    id: "programok",
    title: "Előadások és élményprogramok",
    paragraphs: [
      "Szemléletformáló, interaktív előadások, valamint egy- vagy többnapos élményprogramok a családi dinamikák, az emberi kapcsolódások és az új működések témakörében.",
    ],
    cta: "Megnézem az aktuális programokat",
    to: "/elmenyprogramok",
  },
];

const renderTitle = (title) =>
  title.split("®").map((part, i, arr) => (
    <React.Fragment key={i}>
      {part}
      {i < arr.length - 1 && <sup className="text-gold text-[0.5em]">®</sup>}
    </React.Fragment>
  ));

export default function HomeHowToConnect() {
  return (
    <section
      id="hogyan-kapcsolodhatunk"
      data-testid="home-how-to-connect"
      className="px-5 md:px-10 py-10 md:py-14 border-t border-hairline"
    >
      <SectionTitle testId="home-how-to-connect-title" className="mb-8 md:mb-10">
        Hogyan{" "}
        <em className="text-gold" style={{ fontStyle: "italic" }}>kapcsolódhatunk?</em>
      </SectionTitle>
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
        {WAYS.map((w, i) => (
          <Reveal key={w.id} delay={i * 0.12} className="h-full">
            <article
              data-testid={`home-way-${w.id}`}
              className="h-full bg-warm border border-hairline hover:border-[var(--accent-gold)] transition-colors duration-500 px-7 md:px-9 py-10 md:py-12 flex flex-col text-center"
              style={{ boxShadow: "0 10px 40px -30px rgba(160, 122, 40, 0.3)" }}
            >
              <h3 className="font-serif-display text-[24px] md:text-[27px] leading-[1.25] text-graphite mb-6">
                {renderTitle(w.title)}
              </h3>
              <div className="font-body font-light text-graphite text-[15px] md:text-[15.5px] leading-[1.85] space-y-4 mb-10">
                {w.paragraphs.map((p) => (
                  <p key={p.slice(0, 20)}>{p}</p>
                ))}
              </div>
              <div className="flex-grow" aria-hidden="true" />
              <div className="pt-6 border-t border-hairline">
                <Link
                  to={w.to}
                  data-testid={`home-way-${w.id}-cta`}
                  className="cta-gold-outline inline-flex items-center justify-center gap-3 px-6 py-3.5 text-[11px] md:text-[11.5px] uppercase font-body font-medium tracking-[0.18em]"
                >
                  {w.cta}
                  <span aria-hidden="true">→</span>
                </Link>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
